import Vue from 'vue'
import axios from "axios";
import VueAxios from "vue-axios";

let api = {};
Vue.use(VueAxios, axios)

api.baseURL = 'https://api.particle.io/v1/devices/3c0030000d47303338353831/' //abigail
api.headers = {
	'Authorization': 'Bearer ece057f8704d7312836bb87f696ffa2b37bbc8d5', //abigail
	'Content-Type': 'application/x-www-form-urlencoded'
}


api.go = axios.create({
	baseURL: api.baseURL,
	headers: api.headers,
	timeout: 10000
});



api.dev = function() 
{
	console.log("use dev apis")
	api.baseURL = 'https://api.particle.io/v1/devices/190034000b51373331333230/',//russell
	api.headers = {
		'Authorization': 'Bearer 32b6e25e9ba905d7d64e82c44b6596e110617fa9', //russell
		'Content-Type': 'application/x-www-form-urlencoded'
	}

	api.go = axios.create({
		baseURL: api.baseURL,
		headers: api.headers,
		timeout: 10000
	});
}


//axios.defaults.timeout = 30000;
//const self = api

export { api};